import * as STRINGS from '../strings'

export default {
  [STRINGS.BUTTON_SAFEWALK_ACTIVATE]: 'Starten einen Safe Walk',
  [STRINGS.BUTTON_SAFEWALK_ADD_CONTACTS]: 'Geben Sie die zu benachrichtigenden Kontakte ein.',
  [STRINGS.BUTTON_SAFEWALK_CANCEL_ALARM]: 'Alarm abbrechen.',
  [STRINGS.BUTTON_SAFEWALK_CHECK_IN_TIMER_SET]: 'Check-in auf {{duration}} Minuten eingestellt',
  [STRINGS.BUTTON_SAFEWALK_CHECKIN_TIMER]: 'Stellen Sie den Check-in-Timer für Safe Walk ein',
  [STRINGS.BUTTON_SAFEWALK_END_WALK]: 'Ende ',
  [STRINGS.BUTTON_SAFEWALK_NEW_WALK]: 'Starten Sie einen neuen Safe Walk',
  [STRINGS.BUTTON_SAFEWALK_TRIGGER_ALARM]: 'Alarm',
  [STRINGS.SAFEWALK_ACTIVATED_TEXT]: 'Sie erhalten Benachrichtigungen, wenn Ihr Timer abläuft. Bei Ablauf werden Benachrichtigungen gesendet.',
  [STRINGS.SAFEWALK_ALARM_ACTIVE_BODY_TEXT]: 'Ihr Check-in-Timer für Safe Walk ist abgelaufen. Ihre Organisation und/oder ausgewählte Kontakte wurden benachrichtigt.\nWenn Sie sicher sind, brechen Sie den aktiven Alarm unten ab.',
  [STRINGS.SAFEWALK_ALARM_CANCELLED_BODY_TEXT]: 'Ihre Organisation und/oder ausgewählte Kontakte werden benachrichtigt, dass Ihr Safe-Walk-Alarm deaktiviert wurde. Da sie möglicherweise bereits alarmiert wurden, erhalten Sie möglicherweise Anrufe oder Textnachrichten, um Ihre Sicherheit zu bestätigen.',
  [STRINGS.SAFEWALK_ALARM_ENDED_BODY_TEXT]: 'Ihre Organisation und/oder ausgewählte Kontakte werden benachrichtigt, dass Ihr Safe Walk sicher beendet wurde.',
  [STRINGS.SAFEWALK_ALARM_WARNING_BODY_TEXT]: 'Wenn Ihr Timer abläuft, werden Benachrichtigungen mit Ihrem Standort und verfügbaren Kontaktdaten gesendet',
  [STRINGS.SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT]: 'Safe-Walk-Alarm ausgelöst',
  [STRINGS.SAFEWALK_BUTTON_BEGIN_TEXT]: 'Starten einen Safe Walk',
  [STRINGS.SAFEWALK_BUTTON_WALK_ACTIVE_TEXT]: 'Safe Walk aktiv für',
  [STRINGS.SAFEWALK_BUTTON_WARNING_TEXT]: 'Safe Walk aktiv für',
  [STRINGS.SAFEWALK_CONTACTS_DESCRIPTION]: 'Wenn Ihr Timer abläuft, werden Benachrichtigungen mit Ihrem Standort und verfügbaren Kontaktdaten gesendet.',
  [STRINGS.SAFEWALK_CONTACTS_DISCLAIMER]: 'Omnilert verwendet nur die SMS-Nummer Ihrer Kontakte, um sie während Ihres Safe!talks zu benachrichtigen.',
  [STRINGS.SAFEWALK_CONTACTS_FORM_DESCRIPTION]: 'Optional: Geben Sie unten die SMS-Nummern Ihrer Kontakte ein, um sie zu Ihren SafeWalk-Benachrichtigungen hinzuzufügen. Um fortzufahren, geben Sie SMS-Nummern ein, um Sie über Ihren Safe Walk zu informieren. Wenn Sie einen Alarm auslösen, wird auch Ihr Standort geteilt.',
  [STRINGS.SAFEWALK_CUSTOM_DURATION_TEXT]: 'Stellen Sie eine benutzerdefinierte Timer-Dauer ein.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_BODY]: 'Für eine bessere Standortgenauigkeit laden Sie bitte die App herunter. Wenn Sie fortfahren, lassen Sie den Browser geöffnet und Ihr Telefon entsperrt, um Ihren Standort zu teilen, wenn Ihr Timer abläuft.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_HEADER]: 'Verbessern Sie die Genauigkeit der Notfallortung',
  [STRINGS.SAFEWALK_OFF_CAMPUS_CONTACTS_FORM_DESCRIPTION]: 'Um fortzufahren, geben Sie SMS-Nummern ein, um Sie über Ihren Safe Walk zu informieren. Wenn Sie einen Alarm auslösen, wird auch Ihr Standort geteilt.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_ONE_TEXT]: 'Ihre Organisation hat Ihnen die Nutzung von Safe Walk außerhalb des Campus oder außerhalb der Betriebszeiten ermöglicht. Um einen Spaziergang zu beginnen, müssen Sie Kontakte hinzufügen, um sie zu benachrichtigen.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_TWO_TEXT]: 'Wählen Sie bis zu drei (3) Kontakte aus, um Ihren Standort zu benachrichtigen, wenn Sie einen Alarm auslösen.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_TEXT]: 'Ihre Organisation erlaubt Ihnen, Safe Walk außerhalb des Campus zu verwenden, indem Sie bis zu (3) zu benachrichtigende Kontakte hinzufügen.',
  [STRINGS.SAFEWALK_ON_CAMPUS_QUESTION_TEXT]: 'Bist du auf dem Campus?',
  [STRINGS.SAFEWALK_ON_CAMPUS_TEXT]: 'Ihre Organisation wird möglicherweise benachrichtigt, wenn Sie Ihren Safe Walk starten und wenn Sie einen Alarm auslösen.',
  [STRINGS.SAFEWALK_SMS_DESCRIPTION]: 'Sie erhalten eine SMS und/oder Push-Benachrichtigung, wenn Ihr Timer abläuft.',
  [STRINGS.SAFEWALK_TIMER_EXPIRY_INFO]: 'Wenn Ihr Timer abläuft, werden Benachrichtigungen mit Ihrem Standort und verfügbaren Kontaktdaten gesendet.',

  [STRINGS.BUTTON_DOWNLOAD]: 'Download',
  [STRINGS.BUTTON_OPEN_APP]: 'Offen app',
  [STRINGS.BUTTON_CANCEL]: 'Abbrechen',
  [STRINGS.BUTTON_CLOSE]: 'Schließen',
  [STRINGS.BUTTON_CONTINUE]: 'Weiter',
  [STRINGS.BUTTON_DIAL_911_SHORT]: 'Wählen 911',
  [STRINGS.BUTTON_DIAL_911]: 'Wählen Sie im Notfall 911',
  [STRINGS.BUTTON_EMERGENCY]: 'Drücken und halten Sie um Hilfe',
  [STRINGS.BUTTON_OK]: 'OK',
  [STRINGS.BUTTON_SEND]: 'Senden',
  [STRINGS.BUTTON_SUBMIT_SILENT_ALERT]: 'Stille Benachrichtigung senden',
  [STRINGS.BUTTON_SUBMIT]: 'Senden',
  [STRINGS.BUTTON_TIP_CATEGORY]: 'Keine Kategorie ausgewählt',
  [STRINGS.BUTTON_TIP_LOCATION]: 'Tipp Standort',

  [STRINGS.COMMON_CONFIRM]: 'Yes',
  [STRINGS.COMMON_DENY]: 'No',

  [STRINGS.EMPTY_STATE_RESOURCES]: 'Keine Ressourcen gefunden.',
  
  [STRINGS.ERROR_ACCOUNT_SETUP]:
    'Bei der Einrichtung Ihres Kontos ist ein Problem aufgetreten. Wenden Sie sich an einen Administrator.',
  [STRINGS.ERROR_CONFIG_UNDEFINED]:
    'Es liegt ein Problem mit Ihrem Setup vor. Wenden Sie sich an einen Administrator, um Ihren Push-Endpunkt zu konfigurieren.',
  [STRINGS.ERROR_FIREBASE]:
    'Es gibt ein Problem bei der Kommunikation mit dem Netzwerk. Bitte versuchen Sie Ihren Anruf erneut.',
  [STRINGS.ERROR_TITLE]: 'Ein Fehler ist aufgetreten',
  [STRINGS.ERROR_VALIDATION_401]:
    'Der von Ihnen eingegebene Zugangscode ist ungültig. Bitte stellen Sie sicher, dass Sie es richtig eingegeben haben',
    
  [STRINGS.INDICATOR_NEW_MESSAGES]: 'Neue Nachrichten',
  [STRINGS.INDICATOR_SCROLL]: 'Ungelesene Nachrichten',

  [STRINGS.LABEL_ACCOUNT]: 'Konto',
  [STRINGS.LABEL_TIP_CATEGORY]: 'Tippkategorie auswählen',
  [STRINGS.LABEL_TIP_LOCATION]: 'Aktuellen Standort senden',
  [STRINGS.LABEL_TIP_PRIVATE]: 'Tipp anonym senden',
  [STRINGS.LABEL_TIP_PRIVATE]: 'Privatisieren',

  [STRINGS.LAUNCH]: 'Start',
  [STRINGS.LAUNCH_SCENARIO]: 'Startszenario',
  
  [STRINGS.MESSAGE_TITLE_TIP]: 'Tipp Bericht',
  [STRINGS.MESSAGE_TITLE_TIP_ANONYMOUS]: 'Anonym{{category}}Tipp Bericht',
  [STRINGS.MESSAGE_LOCATION]: 'Bericht locatie',
  [STRINGS.MESSAGE_LOCATION_ERROR_TOAST]:
    'Your organization has requested your location to assist in the current situation. Your response or status will be sent without location unless you re-enable location access.',
  
  [STRINGS.MODAL_BODY_LOCATION_PERMISSION]:
    'Standortberechtigungen sind nicht aktiviert. Bitte aktivieren Sie den Standort, damit unsere Agenten Sie besser unterstützen können. Wichtige Funktionen sind nicht verfügbar, wenn Sie ablehnen.',
  [STRINGS.MODAL_BODY_LOCATION_PERMISSION_DENIED]:
    'Standortberechtigungen wurden verweigert. Bitte aktivieren Sie den Standort, indem Sie in Ihre Geräteeinstellungen gehen. Versuchen Sie es erneut, nachdem Sie den Standort aktiviert haben.',
  [STRINGS.MODAL_BODY_TIP_TITLE]: 'Ihr Tipp wurde eingereicht.',
  [STRINGS.MODAL_BODY_TIP_TITLE_ANON]: 'Ihr Tipp wurde anonym übermittelt.',
  [STRINGS.MODAL_BODY_TIP_BODY]:
    'Vielen Dank für Ihren Bericht. Wir können nicht direkt auf Tippberichte reagieren.',
  [STRINGS.MODAL_BODY_TIP_EMERGENCY]:
    'If this is an emergency, please dial local emergency services.',

  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION]: 'Standortdienste aktivieren',
  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION_DENIED]: 'Ortungsdienste deaktiviert',

  [STRINGS.NO_RESPONSE]: 'Keine Antwort',
  [STRINGS.NOT_AUTH_TITLE]: 'Sie sind leider nicht berechtigt, auf diese Seite zuzugreifen.',
  [STRINGS.NOT_AUTH_SUBTITLE]:
  'Bitte wenden Sie sich an Ihren Systemadministrator, wenn Sie der Meinung sind, dass Sie diese Nachricht irrtümlich erhalten haben.',
  [STRINGS.NOT_FOUND_TITLE]: 'Diese Seite ist leider nicht verfügbar',
  [STRINGS.NOT_FOUND_SUBTITLE]: 'Der Link, den Sie haben, ist möglicherweise defekt. Wir können die gesuchte Ressource nicht finden.',

  [STRINGS.PRIORITY_HEADER_GUN]: 'Waffe erkannt',
  [STRINGS.PRIORITY_HEADER_PANIC]: 'Panikknopf-Alarm',
  [STRINGS.PRIORITY_HEADER_TIP]: 'Tip-Alarm',
  [STRINGS.PRIORITY_FALSE_POSITIVE]: 'Falsch positiv',
  [STRINGS.PRIORITY_MENU_RESOLVE]: 'Problem lösen',
  [STRINGS.PRIORITY_BADGE_RESOLVED]: 'Behoben',

  [STRINGS.PLACEHOLDER_MESSAGE]: 'Tipp hier Nachricht',
  [STRINGS.PLACEHOLDER_RESPONSE]: 'Antwort hier eingeben',
  [STRINGS.PLACEHOLDER_RESOURCES_FILTER]: 'Ressourcen filtern',
  [STRINGS.PLACEHOLDER_TIP]: 'Tipp hier eingeben',

  [STRINGS.PUSH_REG_TEXT]: 'Die Omnilert Mobile App ist für den mobilen Einsatz konzipiert. Bitte öffnen Sie diesen Registrierungslink von Ihrem Mobilgerät aus.',

  [STRINGS.SCREEN_TITLE_TIP]: 'Tipp absenden',
  [STRINGS.SCREEN_TITLE_TIP_LOCATION]: 'Tipp Standort',
  [STRINGS.SCREEN_TITLE_TIP_ATTACHMENT]: 'Attachment',
  [STRINGS.SCREEN_TITLE_TIP_CATEGORY]: 'Tippkategorie auswählen',

  [STRINGS.TAB_TITLE_MESSAGES]: 'Nachrichten',
  [STRINGS.TAB_TITLE_RESOURCES]: 'Ressourcen',
  [STRINGS.TAB_TITLE_SAFEWALK]: 'Bewusster Spaziergang',
  [STRINGS.TAB_TITLE_TIPS]: 'Tips',
  
  [STRINGS.TIP_CATEGORY_DEFAULT]: 'Keine Kategorie ausgewählt',
  [STRINGS.TIP_LOCATION_ERROR_TOAST]:
    'To share the location of your tip with Your organization, please re-enable location access.',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_ONE]: 'If this is a safety emergency,',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_TWO]: 'Dial local emergency services',

  [STRINGS.USER]: 'Benutzer',
  [STRINGS.USERS]: 'Benutzer',
  
  [STRINGS.USER_ERROR_DEFAULT]: 'Ein unbekannter Fehler ist aufgetreten.',
  [STRINGS.USER_ERROR_MAX_UPLOADS]: 'Bitte wählen Sie maximal drei (3) Dateien zum Hochladen aus.',
  [STRINGS.USER_ERROR_1001]:
    'Ihr Gerät wurde nicht aus dem System entfernt. Bitte wenden Sie sich an einen Administrator.',
  [STRINGS.USER_ERROR_1002]:
    'Ihr Gerät wurde nicht aus dem System entfernt. Bitte wenden Sie sich an einen Administrator.',
  [STRINGS.USER_ERROR_2001]:
    'Beim Senden Ihrer Nachricht an unseren Server ist ein Problem aufgetreten. Bitte versuchen Sie es später noch einmal.',
  [STRINGS.USER_ERROR_3001]:
    'Beim Registrieren Ihres Geräts für den Empfang von Push-Benachrichtigungen ist ein Problem aufgetreten. Bitte wenden Sie sich an einen Administrator.',
  [STRINGS.USER_ERROR_3002]:
    'Beim Registrieren Ihres Geräts für den Empfang von Push-Benachrichtigungen ist ein Problem aufgetreten. Bitte wenden Sie sich an einen Administrator.',
  [STRINGS.USER_ERROR_4001]:
    'Beim Registrieren Ihres Geräts beim System ist ein Problem aufgetreten. Bitte wenden Sie sich an einen Administrator.',
  [STRINGS.USER_ERROR_4002]:
    'Ein Zugangscode ist erforderlich. Bitte geben Sie einen gültigen Code ein und versuchen Sie es erneut.',
  [STRINGS.USER_ERROR_4003]:
    'Ihr Zugangscode ist einem nicht ordnungsgemäß konfigurierten Konto zugeordnet. Bitte wenden Sie sich an einen Administrator.',
  [STRINGS.USER_ERROR_4004]:
    'Ihr Zugangscode ist nicht in unserem System registriert. Bitte stellen Sie sicher, dass es korrekt eingegeben wurde.',
  [STRINGS.USER_ERROR_4005]:
    'Es liegt ein Problem mit Ihrem Zugangscode vor. Bitte wenden Sie sich an einen Administrator.',
  [STRINGS.USER_ERROR_4006]:
    'Ihr Zugangscode hat nicht die richtige Länge. Bitte stellen Sie sicher, dass der Code 10 Zeichen enthält.',
  [STRINGS.USER_ERROR_5001]:
    'THier war ein Problem beim Markieren einer Nachricht als gelesen. Bitte versuchen Sie es später noch einmal.'
}
